<template>
  <section
    class="b b-grey-50 lg:grid lg:cols-2 lg:divide-x divide-grey-50 <lg:divide-y"
    data-test-id="product-reviews-pros-cons"
  >
    <div v-if="mostLikedPositive" class="relative px-8 py-4 space-y-2">
      <h3 class="text-xs">
        {{ $t.mostLikedPositiveReview }}
      </h3>
      <div class="flex gap-1">
        <vf-rating :value="mostLikedPositive.rating" />
        <span>({{ getReviewCount(mostLikedPositive.rating) }})</span>
      </div>
      <h5 class="title-5 uppercase">
        {{ mostLikedPositive.headline }}
      </h5>
      <p v-if="mostLikedPositive.comments.length < mostLikedCommentTextThreshold">
        {{ mostLikedPositive.comments }}
      </p>
      <base-collapse
        v-else
        class="break-words"
        class-content="min-h-14"
        class-toggle="mt-2"
        disable-visibility-toggle
        inverted
      >
        <template #toggle="{ expanded }">
          <div class="flex items-center">
            {{ $t.showCompleteReview }}
            <vf-icon :dir="expanded ? 'up' : 'down'" name="chevron" size="md" />
          </div>
        </template>
        <template #default="{ expanded }">
          <p :class="{ 'line-clamp-3': !expanded }">
            {{ mostLikedPositive.comments }}
          </p>
        </template>
      </base-collapse>
      <!-- VS Block -->
      <div
        v-if="mostLikedPositive && mostLikedNegative"
        class="vf-6ht6py "
      >
        {{ $t.versus }}
      </div>
    </div>
    <!-- Negative Block -->
    <div v-if="mostLikedNegative" class="px-8 py-4 space-y-2">
      <p class="text-xs">
        {{ $t.mostLikedNegativeReview }}
      </p>
      <div class="flex gap-1">
        <vf-rating :value="mostLikedNegative.rating" />
        <span>({{ getReviewCount(mostLikedNegative.rating) }})</span>
      </div>
      <h5 class="title-5 uppercase">
        {{ mostLikedNegative.headline }}
      </h5>
      <p v-if="mostLikedNegative.comments.length < mostLikedCommentTextThreshold">
        {{ mostLikedNegative.comments }}
      </p>
      <base-collapse
        v-else
        class="break-words"
        class-content="min-h-14"
        class-toggle="mt-2"
        disable-visibility-toggle
        inverted
      >
        <template #toggle="{ expanded }">
          <div class="flex items-center">
            {{ $t.showCompleteReview }}
            <vf-icon :dir="expanded ? 'up' : 'down'" name="chevron" size="md" />
          </div>
        </template>
        <template #default="{ expanded }">
          <p :class="{ 'line-clamp-3': !expanded }">
            {{ mostLikedNegative.comments }}
          </p>
        </template>
      </base-collapse>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductReviewsRollupFaceoff } from '#root/api/clients/product/data-contracts'

const props = defineProps<{
  mostLikedPositive: ProductReviewsRollupFaceoff | null
  mostLikedNegative: ProductReviewsRollupFaceoff | null
  mostLikedCommentTextThreshold: number
  ratingHistogram: Array<{ rating: number, reviewCount: number }>
}>()

const { $t } = useNuxtApp()

const getReviewCount = (rating: number) =>
  props.ratingHistogram?.find(({ rating: r }) => r === rating)?.reviewCount || 0
</script>
